var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { Component } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import ReactFocusLock from 'react-focus-lock';
import { hideOthers } from 'aria-hidden';
import { focusHiddenMarker, InteractivityDisabler } from "./InteractivityDisabler";

var extractRef = function extractRef(ref) {
  return 'current' in ref ? ref.current : ref;
};

var ReactFocusOn = function (_super) {
  __extends(ReactFocusOn, _super);

  function ReactFocusOn() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.lockProps = {
      onClick: function onClick(e) {
        return _this.lastEventTarget = e.target;
      }
    };

    _this.onActivation = function (node) {
      _this._undo = hideOthers([node].concat((_this.props.shards || []).map(extractRef)), document.body, _this.props.noIsolation ? undefined : focusHiddenMarker);
      var onActivation = _this.props.onActivation;

      if (onActivation) {
        onActivation(node);
      }

      document.addEventListener('keyup', _this.onKeyPress);
      document.addEventListener('click', _this.onClick);
    };

    _this.onDeactivation = function () {
      _this._undo();

      var onDeactivation = _this.props.onDeactivation;

      if (onDeactivation) {
        onDeactivation();
      }

      document.removeEventListener('keyup', _this.onKeyPress);
      document.removeEventListener('click', _this.onClick);
    };

    _this.onKeyPress = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      var code = event.key || event.keyCode;

      if ((event.code === 'Escape' || code === 'Escape' || code === 27) && _this.props.onEscapeKey) {
        _this.props.onEscapeKey(event);
      }
    };

    _this.onClick = function (event) {
      var _a = _this.props,
          _b = _a.shards,
          shards = _b === void 0 ? [] : _b,
          onClickOutside = _a.onClickOutside;

      if (event.defaultPrevented || event.target === _this.lastEventTarget) {
        return;
      }

      if (shards.map(extractRef).some(function (node) {
        return node && node.contains(event.target) || node === event.target;
      })) {
        return;
      }

      if (onClickOutside) {
        onClickOutside();
      }
    };

    return _this;
  }

  ReactFocusOn.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        autoFocus = _a.autoFocus,
        shards = _a.shards,
        _b = _a.enabled,
        enabled = _b === void 0 ? true : _b,
        _c = _a.scrollLock,
        scrollLock = _c === void 0 ? true : _c,
        _d = _a.focusLock,
        focusLock = _d === void 0 ? true : _d;
    return React.createElement(React.Fragment, null, React.createElement(RemoveScroll, {
      enabled: enabled && scrollLock,
      shards: shards
    }, React.createElement(InteractivityDisabler, null), React.createElement(ReactFocusLock, {
      returnFocus: true,
      autoFocus: autoFocus,
      onActivation: this.onActivation,
      onDeactivation: this.onDeactivation,
      disabled: !(enabled && focusLock),
      shards: shards,
      lockProps: this.lockProps
    }, children)));
  };

  return ReactFocusOn;
}(Component);

export { ReactFocusOn };